import React from "react";
import { styled } from "@mui/material";

export function sortDataBySortingNumber(a, b) {
  if (a.sortingNumber < b.sortingNumber) {
    return -1;
  }
  if (a.sortingNumber > b.sortingNumber) {
    return 1;
  }
  return 0;
}

export function sortRequirementsByWeight(a, b) {
  if (a.weight > b.weight) {
    return -1;
  }
  if (a.weight < b.weight) {
    return 1;
  }
  return 0;
}

export const delay = (ms) => new Promise((res) => setTimeout(res, ms));

const interval =
  (delay = 0) =>
  (callback) =>
    React.useEffect(() => {
      const id = setInterval(callback, delay);

      return () => clearInterval(id);
    }, [callback]);

const useTicksInterval = interval(6000);

export const useTimer = ({
  initialTicks = 0,
  initiallyRunning = true,
} = {}) => {
  const [ticks, setTicks] = React.useState(initialTicks);
  const [running, setRunning] = React.useState(initiallyRunning);

  const tick = React.useCallback(
    () => (running ? setTicks((ticks) => (ticks + 1) % 3) : undefined),
    [running]
  );

  const start = () => setRunning(true);
  const pause = () => setRunning(false);
  const reset = () => setTicks(0);
  const stop = () => {
    pause();
    reset();
  };

  useTicksInterval(tick);

  return { pause, reset, running, ticks, start, stop };
};

function getWindowDimensions() {
  const { innerWidth: width, innerHeight: height } = window;
  return {
    width,
    height,
  };
}

export function useWindowDimensions() {
  const [windowDimensions, setWindowDimensions] = React.useState(
    getWindowDimensions()
  );

  React.useEffect(() => {
    function handleResize() {
      setWindowDimensions(getWindowDimensions());
    }

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  return windowDimensions;
}

export const VisuallyHiddenInput = styled("input")({
  clip: "rect(0 0 0 0)",
  clipPath: "inset(50%)",
  height: 1,
  overflow: "hidden",
  position: "absolute",
  bottom: 0,
  left: 0,
  whiteSpace: "nowrap",
  width: 1,
});

export function isInt(value) {
  if (isNaN(value)) {
    return false;
  }
  var x = parseFloat(value);
  return (x | 0) === x;
}

export const isObjectEmpty = (x) => {
  if (typeof x === "object" && !Array.isArray(x) && x !== null) {
    if (Object.keys(x).length !== 0) {
      return false;
    }
  }
  return true;
};

export const removeFields = (obj, fieldsToRemove) => {
  return Object.fromEntries(
    Object.entries(obj).filter(([key]) => !fieldsToRemove.includes(key))
  );
};

export function getEnumKeyByValue(enumObj, value) {
  return Object.keys(enumObj).find((key) => enumObj[key] === value);
}
